var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card__title",
    class: [_vm.sizeString ? 'text-' + _vm.sizeString : '', _vm.colorString ? 'text-' + _vm.colorString : '', {
      'justify-center text-center': _vm.center,
      'justify-end': _vm.right,
      'pb-8': _vm.spacedContent
    }]
  }, [_vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }